import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { EmployeePositionId } from '../../../classes/models/employee/Employee';
import { EmployeeRank } from '../../../classes/models/employee/EmployeeRank';
import { AddEmployeeRankRequest, EditEmployeeRankRequest } from '../../../interfaces/request/EmployeeRequests';

/**
 * This service communicates with backend to handle employee rank data management.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeRankService {
  private http = inject(HttpClient);

  url = environment.apiUrl + '/employees';

  /**
   * Adds a new employee rank to the given employee.
   * @param id identifiers of employee and position.
   * @param employeeRank a new employee rank to be added.
   */
  addEmployeeRank(id: EmployeePositionId, employeeRank: EmployeeRank) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/ranks`;
    const requestBody: AddEmployeeRankRequest = {
      date: employeeRank.startDate,
      rank: employeeRank.rank
    };
    return this.http.post(url, requestBody);
  }

  /**
   * Edits an employee rank for the given employee.
   * @param id identifiers of employee and position.
   * @param employeeRank a new employee rank to be edited.
   */
  editEmployeeRank(id: EmployeePositionId, employeeRank: EmployeeRank) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/ranks/${employeeRank.startDate}`;
    const requestBody: EditEmployeeRankRequest = {
      rank: employeeRank.rank
    };
    return this.http.put(url, requestBody);
  }

  /**
   * Deletes an employee rank for an employee.
   * @param id identifiers of employee and position.
   * @param date start date of employee rank.
   */
  deleteEmployeeRank(id: EmployeePositionId, date: string) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/ranks/${date}`;
    return this.http.delete(url);
  }
}
